var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerActions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "power"
  }, /*#__PURE__*/React.createElement("g", {
    id: "power_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5849 21.2352L28.1973 21.2606C27.645 21.2633 27.1952 20.8177 27.1926 20.2654C27.19 19.7131 27.6356 19.2633 28.1879 19.2607L34.5366 19.2307C35.5896 19.2307 36.2687 20.3492 35.7948 21.248L25.221 43.3602C24.6215 44.4512 22.9686 44.0202 22.9686 42.7807V28.9527H13.4006C12.3522 28.9527 11.6785 27.8438 12.1413 26.9397L22.7402 4.62311C23.3377 3.53568 24.9926 3.95703 24.9926 5.20066V20.2267C24.9926 20.7789 24.5449 21.2267 23.9926 21.2267C23.4403 21.2267 22.9926 20.7789 22.9926 20.2267V8.74993L14.3487 26.9527H22.9692V25.5465C22.9692 24.9942 23.4169 24.5465 23.9692 24.5465C24.5215 24.5465 24.9692 24.9942 24.9692 25.5465V28.1525C24.9692 28.1642 24.969 28.1758 24.9686 28.1874V39.2554L33.5849 21.2352ZM13.935 27.8239C13.9406 27.8129 13.9458 27.8018 13.9507 27.7907L13.935 27.8239Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerActions);
export default __webpack_public_path__ + "static/media/power-actions.a9005f6a5c66a740a299e06034c88b5c.svg";
export { ForwardRef as ReactComponent };